<template>
  <v-layout>
    <v-flex mb-4 mt-4>
      <v-card
        class="mx-auto elevation-4 mt-5"
        max-width="500"
        :dark="config.dark_background"
        :color="config.background_dark"
      >
        <v-toolbar
          v-bind:color="config.primary"
          dark
          flat
        >
          <v-toolbar-title>
            <v-icon>mdi-account-arrow-right</v-icon> Reset Password
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn
          icon
          large
          @click="navigateTo({name: 'login'})"
          >
            <v-icon>mdi-arrow-left</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text class="">
          <v-form
            @submit.prevent="changePassword"
            name="login-form"
            autocomplete="off">
            <v-text-field
              :error="emailError"
              id="email"
              prepend-icon="mdi-email"
              label="Email"
              v-model="email"
              class="mb-3"
            ></v-text-field>
            <v-flex class="d-flex">
              <v-btn
                :loading="changeLoading"
                dark
                class="text-center"
                v-bind:color="config.primary"
                type="submit">
                Request Reset
              </v-btn>
            </v-flex>
          </v-form>
        </v-card-text>
      </v-card>
    </v-flex>
    <v-dialog persistent v-model="successDialog" width="450">
      <modal>
        <template v-slot:toolbar>
          <v-toolbar 
          v-bind:color="config.primary"
          dark
          flat
          >
            <v-row justify="center">
              <v-toolbar-title class="title text-center">
                Just a few more steps...
              </v-toolbar-title>
            </v-row>
          </v-toolbar>
        </template>
        <template v-slot:title>
          <div>

          </div>
        </template>
        <template v-slot:text>
          <v-card-text class="subtitle-1 text-break">
            We have sent you an email at <b>{{email}}</b>. Please check your spam folder to make sure you have it.
            <br>
            <br>
            Follow the instructions in the email for further information.
          </v-card-text>
        </template>
        <template v-slot:actions>
          <v-btn elevation="0" v-if="sentAgain" :loading="changeLoading" class="ml-2 mb-2" dark @click="help()" large :color="config.secondary">
            <v-icon left>mdi-help-circle</v-icon>
            <span>Still not working?</span>
          </v-btn>
          <v-btn elevation="0" v-if="!sentAgain" class="ml-2 mb-2" dark @click="sentAgain = true, changePassword()" large :color="config.secondary">
            <v-icon left>mdi-email</v-icon>
            <span>Send again</span>
          </v-btn>
          <v-btn elevation="0" :loading="loading" class="ml-auto mr-2 mb-2" dark @click="cancelPassword()" large :color="config.primary">
            Go to login
            <v-icon right>mdi-arrow-right</v-icon>
          </v-btn>
        </template>
      </modal>
    </v-dialog>
    <v-dialog persistent v-model="logoutDialog" width="450">
      <modal>
        <template v-slot:toolbar>
          <v-toolbar 
          v-bind:color="config.primary"
          dark
          flat
          >
            <v-row justify="center">
              <v-toolbar-title class="title text-center">
                Click the button below to log out
              </v-toolbar-title>
            </v-row>
          </v-toolbar>
        </template>
        <template v-slot:title>
          <div>

          </div>
        </template>
        <template v-slot:text>
          <v-card-text class="title text-center text-break">
            To reset your password you must be logged out.
          </v-card-text>
        </template>
        <template v-slot:actions>
          <v-container>
            <v-row justify="center">
              <v-col cols="12" sm=6>
                <v-btn block elevation="0" dark @click="logout()" :color="config.confirm">
                  Logout
                  <v-icon right>mdi-exit-to-app</v-icon>
                </v-btn>
              </v-col>
              <v-col cols="12" sm=6>
                <v-btn block elevation="0" dark @click="navigateTo('home')" :color="config.primary">
                  Back to home
                </v-btn>
              </v-col>
            </v-row>
          </v-container>
        </template>
      </modal>
    </v-dialog>
  </v-layout>
</template>

<script>
import config from '@/config/config'
import UserService from '@/services/UserService'
import Modal from '@/components/Modal'
import { mapGetters } from 'vuex'
export default {
  name: 'ForgotPassword',
  data () {
    return {
      settings: {},
      config,
      emailLoading: false,
      passwordLoading: false,
      emailError: false,
      passwordError: false,
      emailDisabled: false,
      passwordDisabled: false,
      email: null,
      password: null,
      successDialog: false,
      loading: false,
      changeLoading: false,
      sentAgain: false,
      logoutDialog: false
    }
  },
  methods: {
    async help () {
      await alert('If you still havent got your email, please try again later. Your password reset will be canceled once you login.')
      this.navigateTo('login')
    },
    async cancelPassword () {
      this.$store.dispatch('setAlert', 'Your password reset will be canceled once you login.')
      this.navigateTo('login')
    },
    navigateTo (route) {
      this.$router.push({name: route})
    },
    async changePassword () {
      if (this.loggedIn) {
        this.$store.dispatch('setAlert', 'You must be logged out to reset your password!')
      } else {
        this.changeLoading = true
        UserService.changePassword({
          email: this.email
        }).then(response => {
          this.email = response.data.email
          this.emailError = false
          this.successDialog = true
          this.changeLoading = false
        }).catch(error => {
          this.changeLoading = false
          this.emailError = true
          this.$store.dispatch('setAlert', error)
        })
      }
    },
    async logout () {
      this.$store.dispatch('logout')
      this.$store.dispatch('setAlert', 'You have been successfully logged out.')
      this.logoutDialog = false
    },
    async checkLogin () {
      if (this.loggedIn == true) {
        this.logoutDialog = true
      }
    }
  },
  components: {
    Modal
  },
  computed: {
    ...mapGetters({
      loggedIn: 'loggedIn',
      getSearchInfo: 'getSearchInfo',
      getUser: 'getUser'
    })
  },
  mounted () {
    this.checkLogin()
  }
}
</script>

<style scoped>

</style>